type RouteParams = Readonly<Record<string, string | undefined>>;

const SPLAT = '*';

export const routePattern = (
  pathname: string,
  params: RouteParams,
): string => {
  const substitutions = Object.entries(params)
    .filter((entry): entry is [string, string] => Boolean(entry[1]))
    .sort(([, left], [, right]) => right.length - left.length);

  return substitutions.reduce(
    (pattern, [key, value]) =>
      pattern.split(value).join(key === SPLAT ? SPLAT : `:${key}`),
    pathname,
  );
};
